import { FC, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import {
    Colors,
    FlexBox,
    Fonts,
    NavBavDropDownSearchTabs,
} from "@brg/ui";
import { useTranslation } from "react-i18next";
import {API, Designer, DesignerAPI, Endpoints, PageModel, Project, Team, TeamAPI} from "@brg/api";
import { useHistory, useRouteMatch } from "react-router-dom";
import {NavbarSearchSelector} from "shared/reducers/NavbarSearch";
import {useSelector} from "react-redux";
import { LayoutConst } from "core/modules/layout.module";
import { CreateExternalLinkTo, CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import { getFindProjectsPageUrl } from "shared/pages/FindProjectsPage/constants";
import {
  getFindLmsSearchPageUrl,
  LMS_DESIGNER_SEARCH_GLOBAL_TYPES,
} from "shared/pages/FindLmsSearchPage/constants";
import { fetchLmsDesignerAutoComplete } from "shared/pages/FindLmsSearchPage/fetchLmsDesignerAutoComplete";
import { computeDesigner } from "shared/helpers/computeData";
import { AppTester } from "supporting";
import { createPortal } from "react-dom";
import { isServer } from "shared/constants/isServer";
import { computeProject } from "shared/helpers/types/computed/ComputedProject";
import { ModalPagination } from "../pagination/modalPagination";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import { computeTeam } from "shared/helpers/types/computed/ComputedTeam";
import { HsePolicies } from "shared/constants/HsePolicies";
import { getCourseImages, getPresentationImages } from "shared/helpers/utils/getPresentationImages";
import placeholderImg from "./assets/placeholder.png"
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { ANIMATION_TAG_ID } from "shared/constants/misc";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";
import Z_INDEX from "shared/constants/Layers";

export const SEARCH_REQUEST_LIMIT = '35';

export const SearchInput = styled.input<{ footer?: boolean }>`
  width: 100%;
  background-color: transparent;
  ${Fonts.Inter.smallText};
  color: ${(p) => p.theme.navigationBar.search.color};
  outline: none !important;
  border: none;
  border-radius: 3px;
  transition: all 0.2s;
  height: 35px;

  ::placeholder {
    color: ${({ theme }) =>  theme.mainSearchBar.input.placeholder.color};
  }
`;

export const SearchLine = styled(FlexBox)`
  background: ${(p) => p.theme.navigationBar.search.line};
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean, footer?: boolean }>`
  align-items: center;
  height: 35px;
  margin-left: 0;
  position: relative;
  justify-content: flex-end;
`;

export const SearchFlexBox = styled(FlexBox)<{footer?: boolean}>`
  height: ${({footer}) => footer ? '24' : '64'}px !important;
  position: relative;
  align-items: center;
  color: ${(p) => p.theme.navigationBar.search.colorFlex};
  min-height: 100%;
`;

export const NavbarSearchWrapper = styled.div<{footer?: boolean}>`
  display: flex;
  cursor: pointer;
  // opacity: 0.47;
  transition: opacity 0.2s;
  align-items: center;
  position: relative;
  svg {
    * {
      fill: ${(p) => p.theme.navigationBar.search.svg} !important;
    }
  }
  &:hover {
    svg {
      * {
        fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
      }
    }
  }

  svg {
    width: ${({footer}) => footer ? '14' : '24'}px !important;
    height: ${({footer}) => footer ? '14' : '24'}px !important;
  }
`;

export const NavbarResultsWrapper = styled.div<{footer?: boolean}>`
  background-color: ${({ theme }) => theme.mainSearchBar.input.bg};
  max-height: 200px;
  width: 324px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px 0;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12);

  ::-webkit-scrollbar {
    width: 0;
  }
  @media(max-width: ${LayoutConst.screen.l_16}px) {
    width: 295px;
  }

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    width: 304px;
  }
`;

export const NavbarResultsItem = styled.div`
  display: flex;
  width: 324px;
  height: 52px;
//   border-bottom: 1px solid ${(p) => p.theme.app.ten};
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 3px;
  background-color: ${(p) => p.theme.mainSearchBar.input.bg};
  :hover {
    background-color: ${(p) => p.theme.app.ten};
  }
  :active {
    background-color: ${Colors.galBlack31};
  }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    width: 295px;
  }

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    width: 304px;
  }

`;

const AutoWrapper = styled.div<{isLogged?: boolean, isCGRAVE?: boolean }>`
  position: fixed;
  top: var(--brg-eco-search-top, 70px);
  right: ${p => p.isLogged? 121 : 32}px;
  z-index: var(--brg-eco-search-z, ${Z_INDEX.navbar_dropdown});

  .dropdown-container {
    position: relative;
    right: 0;
    top: 0;
    height: 95px;
    margin-left: auto;
    width: 460px;

    & > div {
      max-width: 100%;
    }

     &:before {
        content: '';
        position: absolute;
        z-index: -1;
        top: 10px;
        left: -130px;
        right: ${p => p.isLogged? -70 : -25}px;
        bottom: -100px;
    }

    .ui-input_container {
      width: 100%;
      min-width: 0;
      input {
        font-family: 'Inter';
        &::placeholder {
          color: ${({ theme }) => theme.tags.modal.search.color}
        }
      }
    }
    @media(max-width: ${LayoutConst.screen.l_12}px) {
    &:before {
      top: 10px;
      left: -85px;
     right: ${p => p.isLogged? -45 : -10}px;
      bottom: -100px;
    }
    }

    .search-msg, .item {
      width: 100% !important;
    }
    .item {
    :not(.search-msg) {
      :hover {
        background-color: ${({isCGRAVE}) => isCGRAVE ? '#464645' : ''};
      }
    }
  }
    .result-wrapper {
      max-width: 100%;
      margin-left: auto;
      max-height: 192px;
    }

  }

  .search-flex-wrapper {
    margin-right: 0 !important;
  }

  .icon-wrapper {
    display: none !important;
  }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    right: ${p => p.isLogged? 88 : 26}px;
  }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    right: ${p => p.isLogged? 60 : 16}px;

    .search-flex-wrapper {
      margin-top: 8px;
    }
  }
`;

export interface MainMenuSearchBarProps {
  onSearch?: (searchValue: string) => Promise<boolean>;
  isFooterItem?: boolean;
  orientation?: 'left' | 'right';
  autoOpen?: boolean;
  onClose?: () => void;
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
};

const useCompactSearchTop = (isOpen?: boolean) => {
  const [top, setTop] = useState<number>();

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const measure = () => {
      const root = document.documentElement;
      const navbar = document.getElementById('navbar');
      if (!navbar || window.innerWidth >= 1200 || getComputedStyle(root).getPropertyValue('--brg-eco-search-top').trim()) {
        setTop(undefined);
        return;
      }
      setTop(Math.max(0, Math.round(navbar.getBoundingClientRect().bottom)) + 22);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [isOpen]);

  return top;
};

export const DropdownSearchBar: FC<MainMenuSearchBarProps> = ({isFooterItem , orientation = 'left', autoOpen = false, onClose }) => {
  const [designers, setDesigners] = useState<Designer[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [teams, setTeams] = useState<Project[]>([]);
  const [channels, setChannels] = useState<Team[]>([]);
  const [organizations, setOrganizations] = useState<Team[]>([]);
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isDesignersLoading, setIsDesignersLoading] = useState(false);
  const [combineData, setCombineData] = useState([])
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const [searchText, setSearchText] = useState("");
  const [isEmpty, setIsEmpty] = useState(false);
  const isGeo = AppTester.isGeograffee()
  const isSuperpuper = AppTester.isSuperPuper()
  const isCGRAVE = AppTester.isCGRAVE()
  const isLPU = AppTester.isLPUDesign()
  const isContinuumSite = AppTester.isContinuumSite()
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const profile = useProfile();
  const isLMS = AppTester.isLMSHSE() || AppTester.isLMSHSECreative();
  const isGreenAward = AppTester.isGreenAward();
  const isHseAnimation = AppTester.isHseAnimation();

  const {
    isAKI,
  } = useAppTester();
  
  const isOpen = useSelector(NavbarSearchSelector).open;
  const compactTop = useCompactSearchTop(isOpen);
  const wrapperStyle = compactTop === undefined ? undefined : { top: compactTop };

  const globalTypes = useMemo(() => {
    if (isAKI) {
      return ['Creatoraki'];
    }
    if (isLPU) {
      return ['lpuemployee'];
    }
    if (isLMS) {
      return [...LMS_DESIGNER_SEARCH_GLOBAL_TYPES];
    }
    return [];
  }, [isAKI, isLPU, isLMS])
  const includeContexts = useMemo<string[]>(() => {
    if (isGreenAward) return ['greenawards'];
    if (isAKI) return ['aki'];
    return [];
  }, [isGreenAward, isAKI]);

  const additionalProjectParams = useMemo(() => {
    if (isHseAnimation) {
      return {
        tagIds: [ANIMATION_TAG_ID]
      }
    }
    return {}
  }, [isHseAnimation])

  const lmsSearchFetchIdRef = useRef(0);
  const lmsActiveSearchRef = useRef('');

  const fetchProjects = async () => {
    setIsLoading(true)
    const req = API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/project/AutoCompletePaging')
      .get()
      .addQuery('key', searchText)
      .addQuery('page', currentPage)
      .addQuery('limit', SEARCH_REQUEST_LIMIT)
    if (includeContexts.length > 0) {
      req.addQuery('includeContexts', includeContexts);
    }
    Object.entries(additionalProjectParams).forEach(([key, value]) => {
      req.addQuery(key, value);
    })
    const response = await req.send()
    const json = await response.json()
    const v = API.toLang<PageModel<Project>>(json, i18n.language)
        setProjects(v.data);
    // @ts-ignore
        setPages(v.paging.pages);
    // @ts-ignore
        setIsEmpty(v.data.length < 1);
        setIsLoading(false);
  }

  const additionalDesignerParams = useMemo(() => {
    if (isHseAnimation) {
      return {
        projectTagIds: [ANIMATION_TAG_ID]
      }
    }
    return {}
  }, [isHseAnimation])

  const fetchDesigners = async (options?: { lmsFetchId?: number }) => {
    const designerParams = {
      key: searchText,
      ...(globalTypes?.length && { globalTypes }),
      ...additionalDesignerParams,
    };

    if (options?.lmsFetchId != null) {
      setIsDesignersLoading(true);
    }

    const designerRequest = isLMS
      ? fetchLmsDesignerAutoComplete(searchText)
      : DesignerAPI.AutoComplete(designerParams);

    return designerRequest
      .then((v) => v.json())
      .then((raw) => API.toLang<Designer[]>(raw, i18n.language))
      .then((v) => {
        if (
          options?.lmsFetchId != null &&
          options.lmsFetchId !== lmsSearchFetchIdRef.current
        ) {
          return;
        }
        setDesigners(v);
      })
      .finally(() => {
        if (
          options?.lmsFetchId != null &&
          options.lmsFetchId === lmsSearchFetchIdRef.current
        ) {
          setIsDesignersLoading(false);
        }
      });
  };

  const fetchLmsCourses = async (lmsFetchId: number) => {
    setIsLoading(true);
    try {
      const response = await API.request()
        .endpoint(Endpoints.geograffee)
        .url("/api/LMS/AutoCompletePaging")
        .get()
        .addQuery("key", searchText)
        .addQuery("page", currentPage)
        .addQuery("limit", SEARCH_REQUEST_LIMIT)
        .send();
      const json = await response.json();
      if (lmsFetchId !== lmsSearchFetchIdRef.current) {
        return;
      }
      const v = API.toLang<PageModel<Project>>(json, i18n.language);
      setTeams(v.data ?? []);
      // @ts-ignore
      setPages(v.paging?.pages ?? 0);
    } finally {
      if (lmsFetchId === lmsSearchFetchIdRef.current) {
        setIsLoading(false);
      }
    }
  };

  // const fetchChannels = async () => {
  //   setIsLoading(true)
  //   return (
  //     API.request()
  //     .endpoint(Endpoints.geograffee)
  //     .url('/api/Team/GetChannelsAutoCompletePaging')
  //     .get()
  //     .addQuery('key', searchText)
  //     .addQuery('page', currentPage)
  //     .addQuery('limit', SEARCH_REQUEST_LIMIT)
  //     .send()
  //     .then((v) => v.json())
  //     .then((v) => {
  //       setChannels(API.toLang<Team[]>(v.data, i18n.language));
  //       setPages(v.paging.pages);
  //       setIsEmpty(v.length < 1);
  //       setIsLoading(false);
  //     })
  //   )
  // }

  const fetchOrganizations = async () => {
    const orgParams = {
      key: searchText,
      limit: Number(SEARCH_REQUEST_LIMIT),
    };

    const v = await TeamAPI.TeamAutoComplete(orgParams);
    const json = await v.json();
    const data = API.toLang<Team[]>(json, i18n.language);
    setOrganizations(Array.isArray(data) ? data : []);
  };

  useLayoutEffect(() => {
    if (!isLMS || searchText.length < 2) return;
    setIsLoading(true);
    setIsDesignersLoading(true);
  }, [searchText, isLMS]);

  useEffect(() => {
    if (!isLMS || searchText.length < 2) return;
    if (isLoading || isDesignersLoading) {
      setIsEmpty(false);
      return;
    }
    if (lmsActiveSearchRef.current !== searchText) {
      setIsEmpty(false);
      return;
    }
    if (designers.length === 0 && teams.length > 0) {
      setIsEmpty(true);
      return;
    }
    setIsEmpty(designers.length === 0 && teams.length === 0);
  }, [
    isLMS,
    searchText,
    isLoading,
    isDesignersLoading,
    designers.length,
    teams.length,
  ]);

  useDebouncedEffect(
    () => {
      if (searchText.length >= 2) {
        if(isLMS){
          lmsActiveSearchRef.current = searchText;
          const fetchId = ++lmsSearchFetchIdRef.current;
          fetchLmsCourses(fetchId);
          fetchDesigners({ lmsFetchId: fetchId });
        }else{
          fetchProjects();
          fetchDesigners();
          if (!isAKI) {
            // fetchChannels();
            fetchOrganizations();
          }
        }
      } else {
        lmsSearchFetchIdRef.current += 1;
        lmsActiveSearchRef.current = '';
        setIsLoading(false);
        setIsDesignersLoading(false);
        setIsEmpty(false);
        setDesigners([]);
        setProjects([]);
        setTeams([]);
        // setChannels([]);
        setOrganizations([]);
      }
    },
    [searchText, i18n.language, currentPage],
    700
  );


  
  useEffect(() => {
    if(isLMS){
      //@ts-ignore
      setCombineData([...designers, ...(teams ?? [])]);
    } else if(isGreenAward){
      //@ts-ignore
      setCombineData([...(projects ?? [])])
    } else if (isAKI) {
      //@ts-ignore
      setCombineData([...designers, ...(projects ?? [])])
    } else {
      //@ts-ignore
      setCombineData([
        ...designers,
        ...(projects ?? []),
        // ...(channels ?? []) /*дублирование. каналы = организации*/,
        ...(organizations ?? []),
      ]);
    }
  }, [designers, projects, teams, channels, organizations, isLMS, isGreenAward, isAKI])

  useEffect(() => {
    const STYLE_ID = 'blur-18-style';
    document.getElementById(STYLE_ID)?.remove();
  
    const rules = combineData
      .map((item: any, idx: number) =>
        item.isAgeRestricted
          ? `.dropdown-search-auto-wrapper .item:nth-child(${idx + 1}) img { filter: blur(4px); }`
          : ''
      )
      .filter(Boolean)
      .join('\n');
  
    if (rules) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.innerHTML = rules;
      document.head.appendChild(style);
    }
  }, [combineData]);
  

  useEffect(() => {
    setCurrentPage(1)
  }, [isOpen])

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') return;
      if (!isOpen) return;
      const active = document.activeElement as HTMLElement | null;
      const wrapper = document.querySelector('.dropdown-search-auto-wrapper') as HTMLElement | null;
      const isTextInput =
        !!active &&
        (active.tagName === 'INPUT' ||
          active.tagName === 'TEXTAREA' ||
          !!(active as any).isContentEditable);
      if (wrapper) {
        if (!active || !wrapper.contains(active)) return;
      } else if (!isTextInput) {
        return;
      }
      if (searchText.trim().length >= 2 && !isAKI) {
        e.preventDefault();
        onClose?.();
        if (isLMS) {
          history.push(getFindLmsSearchPageUrl(searchText.trim()));
        } else {
          history.push(getFindProjectsPageUrl(searchText.trim()));
        }
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [searchText, isAKI, isLMS, onClose, history, isOpen]);

  //Сделал временно, потому что падало перед деплоем
  const isSearchResultLmsClick = useCallback((item: any, isProject?: boolean, isTeam?: boolean, isChannels?: boolean) => {
    let path: string;
    if (isProject) {
      path = CreateLinkTo.projectNew(item);
    } else if (isChannels) {
      path = CreateExternalLinkTo.mediiia('/teams/' + item?.teamId);
    } else if (isTeam) {
      path = CreateLinkTo.team(item?.teamId);
    } else {
      path = CreateLinkTo.designerNew(item);
    }
    onClose?.();
    window.open(path, '_blank', 'noopener,noreferrer');
  }, [onClose]);

  const mapLmsSearchResultItem = useCallback(
    (item: any) => {
      const cv = computeDesigner(item, { showFullName: true });
      const team = computeTeam(item);
      const isDesignerItem =
        !!(item?.designerId || item?.accountId) && !item?.teamId && !item?.projectId;

      if (isDesignerItem) {
        return {
          onClick: () => isSearchResultLmsClick(cv, false, false, false),
          avatarCV: cv,
          name: cv?.fullName || "",
          title: "",
          titleImages: [] as unknown,
          projectId: "",
          projectType: undefined,
          designerId: cv?.designerId || "",
          id: cv?.designerId,
          teamId: "",
          isProject: false,
          isTeam: false,
          isChannels: false,
        };
      }

      const imagesContainer = getCourseImages(item);
      const images = imagesContainer?.[0]?.files;
      const isTeam =
        !!item?.teamId &&
        ![ModerationType.Outer, ModerationType.ChannelGroupOrCourse]?.includes(
          item.moderationType,
        );
      const isChannels =
        item?.teamId &&
        [ModerationType.Outer, ModerationType.ChannelGroupOrCourse]?.includes(
          item.moderationType,
        );

      const searchMatch = item?.searchMatch as
        | { field?: number; values?: string[]; fragments?: string[] }
        | undefined;

      return {
        onClick: () =>
          isSearchResultLmsClick(team, false, isTeam, isChannels),
        avatarCV: cv,
        name: team?.name || team?.displayName || "",
        title: team?.name || team?.displayName || "",
        searchMatchField: searchMatch?.field,
        searchMatchValues: searchMatch?.values,
        searchMatchFragments: searchMatch?.fragments,
        // @ts-ignore
        titleImages: item?.titleImages?.length
          ? item?.titleImages
          : images?.length
            ? images
            : ([] as unknown),
        projectId: "",
        projectType: undefined,
        designerId: "",
        id: item?.teamId,
        teamId: team?.teamId || item?.teamId,
        isProject: false,
        isTeam,
        isChannels,
      };
    },
    [isSearchResultLmsClick],
  );

  const onSearchResultItemClick = useCallback((item: any) => {
    let path: string;
    if (item?.hasOwnProperty('projectId')) {
      path = CreateLinkTo.projectNew(item);
    } else if (item?.hasOwnProperty('teamId') && item?.hasOwnProperty('moderationType')) {
      path = CreateExternalLinkTo.mediiia('/teams/' + item?.teamId);
    } /*else if (isTeam) {
      path = CreateLinkTo.team(item?.teamId);
    } */else {
      path = CreateLinkTo.designerNew(item);
    }
    onClose?.();
    window.open(path, '_blank', 'noopener,noreferrer');
  }, [onClose]);


  const SearchPortal = useMemo(() => {
    if (isServer) return null;
    if (isLMS) {
      
      const outer = document.querySelector('#navbar-portal');

      if (!outer && !isOpen) return null;
  
      if (outer) {
            //@ts-ignore
        outer.style.position = 'relative';
      }
  
      return createPortal(
  
        <AutoWrapper className="dropdown-search-auto-wrapper" isLogged={!!profile}  isCGRAVE={isCGRAVE || isContinuumSite} style={wrapperStyle}>
        <NavBavDropDownSearchTabs
        resultsData={[...combineData].map(mapLmsSearchResultItem)}
        searchText={searchText}
        setSearchText={setSearchText}
        isEmpty={isEmpty}
        isLMS={isLMS}
        Endpoints={Endpoints}
        isLoading={isLoading || isDesignersLoading}
        pages={pages}
        placeholderImg={placeholderImg}
        minTextLength={2}
        orientation={orientation}
        onClose={onClose}
        onWhiteBg={!isGeo && !isSuperpuper}
        autoOpen={autoOpen}
        forceOpen={true}
        initialTab="projects"
        tabsOrder={['projects', 'people']}
        tabsLoading={{
          projects: isLoading,
          people: isDesignersLoading,
        }}
        showAllButton={{
          label: t("show_all"),
          getHref: (search) => getFindLmsSearchPageUrl(search),
        }}
        texts={{
            needMoreChars: t('text.more2chars'),
            loading: t('text.loading'),
            notFound: t('text.notfound'),
            newSearch: t('new_search_common_lms'),
            hintTooltip: t("hints.search_lms"),
            tabs: {
              people: t("main_search.tabs.people"),
              projects: t("main_search.tabs.courses"),
            }
        }}
        modalPaginationComponent={
          <ModalPagination
              pages={pages}
              page={currentPage}
              onPageChange={(page) => {
                  setCurrentPage(page);
              }}
          />
      }
    />
          </AutoWrapper>
       ,
       outer as Element,
      );
    }

    if (autoOpen) {
      const outer = document.querySelector('#navbar-portal');

      if (!outer && !isOpen) return null;
  
      if (outer) {
            //@ts-ignore
        outer.style.position = 'relative';
      }
  
      return createPortal(
  
        <AutoWrapper className="dropdown-search-auto-wrapper" isLogged={!!profile}  isCGRAVE={isCGRAVE || isContinuumSite} style={wrapperStyle}>
        <NavBavDropDownSearchTabs
        resultsData={[...combineData].map((item) => {
  
          const cv = computeDesigner(item, { showFullName: true });
          const project = computeProject(item);
          //const team = computeTeam(item);
          const channel = computeTeam(item);
          //@ts-ignore
          const isProject = !!item?.projectId
          const isCommonTeamSign = !!channel?.teamId;
          const images = getPresentationImages(item)

          let entity: any | undefined = undefined;
          
          if (isProject) {
            entity = project;
          } else if (isCommonTeamSign) {
            entity = channel;
          } else {
            entity = cv;
          }

          return {
            onClick: () => onSearchResultItemClick(entity),
              avatarCV: cv,
              name: cv?.fullName || '',
              title: entity?.title || '',
              titleImages: entity?.titleImages || images || [] as unknown,
              projectId: entity?.projectId || '',
              projectType: entity?.projectType,
              designerId: !isProject && !isCommonTeamSign ? (entity?.designerId || '') : '',
              id: project?.projectId || cv?.designerId || channel?.teamId,
              teamId: entity?.teamId ?? '',
              isProject: isProject, 
              isTeam: undefined,
              isChannels: isCommonTeamSign
          }
      })}
        searchText={searchText}
        setSearchText={setSearchText}
        isEmpty={isEmpty}
        Endpoints={Endpoints}
        isLoading={isLoading}
        pages={pages}
        minTextLength={2}
        orientation={orientation}
        onClose={onClose}
        onWhiteBg={!isGeo && !isSuperpuper}
        autoOpen={autoOpen}
        forceOpen={true}
        showAllButton={!isAKI ? { label: t('show_all'), getHref: (search) => getFindProjectsPageUrl(search) } : undefined}
        texts={{
            needMoreChars: t('text.more2chars'),
            loading: t('text.loading'),
            notFound: t('text.notfound'),
            newSearch: t(isGreenAward ? 'new_search_prject' : 'new_search_common'),
            hintTooltip: t("hints.search"),
            tabs: {
              people: t("main_search.tabs.people"),
              projects: t("main_search.tabs.projects"),
              channels: t("main_search.tabs.organizations"),
            }
        }}
        modalPaginationComponent={
          <ModalPagination
              pages={pages}
              page={currentPage}
              onPageChange={(page) => {
                  setCurrentPage(page);
              }}
          />
      }
    />
          </AutoWrapper>
       ,
       outer as Element,
      );
    }
   
  
    // @ts-ignore
    const mappedResults = [...combineData].map((item) => {
          const cv = computeDesigner(item,  { showFullName: true });
          const project = computeProject(item);
          const channel = computeTeam(item);
          const isProject = !!project?.projectId;
          const isCommonTeamSign = !!channel?.teamId

          let entity: any | undefined = undefined;
          
          if (isProject) {
            entity = project;
          } else if (isCommonTeamSign) {
            entity = channel;
          } else {
            entity = cv;
          }

          return {
            onClick: () => onSearchResultItemClick(entity),
            avatarCV: cv,
            name: cv?.fullName || '',
            title: project?.title || '',
            titleImages: project?.titleImages || [] as unknown,
            projectId: project?.projectId || '',
            designerId: !isProject && !isCommonTeamSign ? (entity?.designerId || '') : '',
            projectType: project?.projectType,
            id: project?.projectId || cv?.designerId || channel?.teamId,
            teamId: channel?.teamId ?? '',
            isProject: isProject,
            isChannels: isCommonTeamSign
          }
      });
    const showAllItem = !isAKI && searchText.trim().length >= 2 ? {
      designerId: '__show_all__' as const,
      name: t('show_all'),
      onClick: () => {
        onClose?.();
        window.open(getFindProjectsPageUrl(searchText.trim()), '_blank', 'noopener,noreferrer');
      },
    } : null;
    const resultsData: any[] = showAllItem ? [showAllItem, ...mappedResults] : mappedResults;


    return (      <NavBavDropDownSearchTabs
      resultsData={resultsData}
      searchText={searchText}
      setSearchText={setSearchText}
      isEmpty={isEmpty}
      isLoading={isLoading}
      pages={pages}
      minTextLength={2}
      orientation={orientation}
      Endpoints={Endpoints}
      autoOpen={autoOpen}
      onWhiteBg={!isGeo && !isSuperpuper}
      modalPaginationComponent={
        <ModalPagination
            pages={pages}
            page={currentPage}
            onPageChange={(page) => {
                setCurrentPage(page);
            }}
        />
      }
      texts={{
          needMoreChars: t('text.more2chars'),
          loading: t('text.loading'),
          notFound: t('text.notfound'),
          newSearch: t('new_search'),
          hintTooltip: t("hints.search"),
          tabs: {
            people: t("main_search.tabs.people"),
            projects: t("main_search.tabs.projects"),
            // organizations: t("main_search.tabs.organizations"),
            ...(!isAKI && { channels: t("main_search.tabs.channels") })
          }
      }}
  />
    )
   
  }, [
    isOpen,
    autoOpen,
    searchText,
    isSuperpuper,
    isGeo,
    designers,
    teams,
    projects,
    combineData,
    isEmpty,
    isLoading,
    isDesignersLoading,
    pages,
    currentPage,
    isLMS,
    isAKI,
    isGreenAward,
    mapLmsSearchResultItem,
    t,
    orientation,
    onClose,
    profile,
    isCGRAVE,
    isContinuumSite,
    Endpoints,
  ])


  if (autoOpen && !isOpen) return null;

  return (
      <>
        {SearchPortal}
      </>
  );
};import { FC, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import {
    Colors,
    FlexBox,
    Fonts,
    NavBavDropDownSearchTabs,
} from "@brg/ui";
import { useTranslation } from "react-i18next";
import {API, Designer, DesignerAPI, Endpoints, PageModel, Project, Team, TeamAPI} from "@brg/api";
import { useHistory, useRouteMatch } from "react-router-dom";
import {NavbarSearchSelector} from "shared/reducers/NavbarSearch";
import {useSelector} from "react-redux";
import { LayoutConst } from "core/modules/layout.module";
import { CreateExternalLinkTo, CreateLinkTo, LinkTo } from "shared/constants/linkTo";
import { getFindProjectsPageUrl } from "shared/pages/FindProjectsPage/constants";
import {
  getFindLmsSearchPageUrl,
  LMS_DESIGNER_SEARCH_GLOBAL_TYPES,
} from "shared/pages/FindLmsSearchPage/constants";
import { fetchLmsDesignerAutoComplete } from "shared/pages/FindLmsSearchPage/fetchLmsDesignerAutoComplete";
import { computeDesigner } from "shared/helpers/computeData";
import { AppTester } from "supporting";
import { createPortal } from "react-dom";
import { isServer } from "shared/constants/isServer";
import { computeProject } from "shared/helpers/types/computed/ComputedProject";
import { ModalPagination } from "../pagination/modalPagination";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import { computeTeam } from "shared/helpers/types/computed/ComputedTeam";
import { HsePolicies } from "shared/constants/HsePolicies";
import { getCourseImages, getPresentationImages } from "shared/helpers/utils/getPresentationImages";
import placeholderImg from "./assets/placeholder.png"
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { ANIMATION_TAG_ID } from "shared/constants/misc";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";
import Z_INDEX from "shared/constants/Layers";

export const SEARCH_REQUEST_LIMIT = '35';

export const SearchInput = styled.input<{ footer?: boolean }>`
  width: 100%;
  background-color: transparent;
  ${Fonts.Inter.smallText};
  color: ${(p) => p.theme.navigationBar.search.color};
  outline: none !important;
  border: none;
  border-radius: 3px;
  transition: all 0.2s;
  height: 35px;

  ::placeholder {
    color: ${({ theme }) =>  theme.mainSearchBar.input.placeholder.color};
  }
`;

export const SearchLine = styled(FlexBox)`
  background: ${(p) => p.theme.navigationBar.search.line};
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean, footer?: boolean }>`
  align-items: center;
  height: 35px;
  margin-left: 0;
  position: relative;
  justify-content: flex-end;
`;

export const SearchFlexBox = styled(FlexBox)<{footer?: boolean}>`
  height: ${({footer}) => footer ? '24' : '64'}px !important;
  position: relative;
  align-items: center;
  color: ${(p) => p.theme.navigationBar.search.colorFlex};
  min-height: 100%;
`;

export const NavbarSearchWrapper = styled.div<{footer?: boolean}>`
  display: flex;
  cursor: pointer;
  // opacity: 0.47;
  transition: opacity 0.2s;
  align-items: center;
  position: relative;
  svg {
    * {
      fill: ${(p) => p.theme.navigationBar.search.svg} !important;
    }
  }
  &:hover {
    svg {
      * {
        fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
      }
    }
  }

  svg {
    width: ${({footer}) => footer ? '14' : '24'}px !important;
    height: ${({footer}) => footer ? '14' : '24'}px !important;
  }
`;

export const NavbarResultsWrapper = styled.div<{footer?: boolean}>`
  background-color: ${({ theme }) => theme.mainSearchBar.input.bg};
  max-height: 200px;
  width: 324px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px 0;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12);

  ::-webkit-scrollbar {
    width: 0;
  }
  @media(max-width: ${LayoutConst.screen.l_16}px) {
    width: 295px;
  }

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    width: 304px;
  }
`;

export const NavbarResultsItem = styled.div`
  display: flex;
  width: 324px;
  height: 52px;
//   border-bottom: 1px solid ${(p) => p.theme.app.ten};
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 3px;
  background-color: ${(p) => p.theme.mainSearchBar.input.bg};
  :hover {
    background-color: ${(p) => p.theme.app.ten};
  }
  :active {
    background-color: ${Colors.galBlack31};
  }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    width: 295px;
  }

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    width: 304px;
  }

`;

const AutoWrapper = styled.div<{isLogged?: boolean, isCGRAVE?: boolean }>`
  position: fixed;
  top: var(--brg-eco-search-top, 70px);
  right: ${p => p.isLogged? 121 : 32}px;
  z-index: var(--brg-eco-search-z, ${Z_INDEX.navbar_dropdown});

  .dropdown-container {
    position: relative;
    right: 0;
    top: 0;
    height: 95px;
    margin-left: auto;
    width: 460px;

    & > div {
      max-width: 100%;
    }

     &:before {
        content: '';
        position: absolute;
        z-index: -1;
        top: 10px;
        left: -130px;
        right: ${p => p.isLogged? -70 : -25}px;
        bottom: -100px;
    }

    .ui-input_container {
      width: 100%;
      min-width: 0;
      input {
        font-family: 'Inter';
        &::placeholder {
          color: ${({ theme }) => theme.tags.modal.search.color}
        }
      }
    }
    @media(max-width: ${LayoutConst.screen.l_12}px) {
    &:before {
      top: 10px;
      left: -85px;
     right: ${p => p.isLogged? -45 : -10}px;
      bottom: -100px;
    }
    }

    .search-msg, .item {
      width: 100% !important;
    }
    .item {
    :not(.search-msg) {
      :hover {
        background-color: ${({isCGRAVE}) => isCGRAVE ? '#464645' : ''};
      }
    }
  }
    .result-wrapper {
      max-width: 100%;
      margin-left: auto;
      max-height: 192px;
    }

  }

  .search-flex-wrapper {
    margin-right: 0 !important;
  }

  .icon-wrapper {
    display: none !important;
  }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    right: ${p => p.isLogged? 88 : 26}px;
  }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    right: ${p => p.isLogged? 60 : 16}px;

    .search-flex-wrapper {
      margin-top: 8px;
    }
  }
`;

export interface MainMenuSearchBarProps {
  onSearch?: (searchValue: string) => Promise<boolean>;
  isFooterItem?: boolean;
  orientation?: 'left' | 'right';
  autoOpen?: boolean;
  onClose?: () => void;
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
};

const useCompactSearchTop = (isOpen?: boolean) => {
  const [top, setTop] = useState<number>();

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const measure = () => {
      const root = document.documentElement;
      const navbar = document.getElementById('navbar');
      if (!navbar || window.innerWidth >= 1200 || getComputedStyle(root).getPropertyValue('--brg-eco-search-top').trim()) {
        setTop(undefined);
        return;
      }
      setTop(Math.max(0, Math.round(navbar.getBoundingClientRect().bottom)) + 22);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [isOpen]);

  return top;
};

export const DropdownSearchBar: FC<MainMenuSearchBarProps> = ({isFooterItem , orientation = 'left', autoOpen = false, onClose }) => {
  const [designers, setDesigners] = useState<Designer[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [teams, setTeams] = useState<Project[]>([]);
  const [channels, setChannels] = useState<Team[]>([]);
  const [organizations, setOrganizations] = useState<Team[]>([]);
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isDesignersLoading, setIsDesignersLoading] = useState(false);
  const [combineData, setCombineData] = useState([])
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const [searchText, setSearchText] = useState("");
  const [isEmpty, setIsEmpty] = useState(false);
  const isGeo = AppTester.isGeograffee()
  const isSuperpuper = AppTester.isSuperPuper()
  const isCGRAVE = AppTester.isCGRAVE()
  const isLPU = AppTester.isLPUDesign()
  const isContinuumSite = AppTester.isContinuumSite()
  const isProfile = !!useRouteMatch(LinkTo.designer);
  const profile = useProfile();
  const isLMS = AppTester.isLMSHSE() || AppTester.isLMSHSECreative();
  const isGreenAward = AppTester.isGreenAward();
  const isHseAnimation = AppTester.isHseAnimation();

  const {
    isAKI,
  } = useAppTester();
  
  const isOpen = useSelector(NavbarSearchSelector).open;
  const compactTop = useCompactSearchTop(isOpen);
  const wrapperStyle = compactTop === undefined ? undefined : { top: compactTop };

  const globalTypes = useMemo(() => {
    if (isAKI) {
      return ['Creatoraki'];
    }
    if (isLPU) {
      return ['lpuemployee'];
    }
    if (isLMS) {
      return [...LMS_DESIGNER_SEARCH_GLOBAL_TYPES];
    }
    return [];
  }, [isAKI, isLPU, isLMS])
  const includeContexts = useMemo<string[]>(() => {
    if (isGreenAward) return ['greenawards'];
    if (isAKI) return ['aki'];
    return [];
  }, [isGreenAward, isAKI]);

  const additionalProjectParams = useMemo(() => {
    if (isHseAnimation) {
      return {
        tagIds: [ANIMATION_TAG_ID]
      }
    }
    return {}
  }, [isHseAnimation])

  const lmsSearchFetchIdRef = useRef(0);
  const lmsActiveSearchRef = useRef('');

  const fetchProjects = async () => {
    setIsLoading(true)
    const req = API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/project/AutoCompletePaging')
      .get()
      .addQuery('key', searchText)
      .addQuery('page', currentPage)
      .addQuery('limit', SEARCH_REQUEST_LIMIT)
    if (includeContexts.length > 0) {
      req.addQuery('includeContexts', includeContexts);
    }
    Object.entries(additionalProjectParams).forEach(([key, value]) => {
      req.addQuery(key, value);
    })
    const response = await req.send()
    const json = await response.json()
    const v = API.toLang<PageModel<Project>>(json, i18n.language)
        setProjects(v.data);
    // @ts-ignore
        setPages(v.paging.pages);
    // @ts-ignore
        setIsEmpty(v.data.length < 1);
        setIsLoading(false);
  }

  const additionalDesignerParams = useMemo(() => {
    if (isHseAnimation) {
      return {
        projectTagIds: [ANIMATION_TAG_ID]
      }
    }
    return {}
  }, [isHseAnimation])

  const fetchDesigners = async (options?: { lmsFetchId?: number }) => {
    const designerParams = {
      key: searchText,
      ...(globalTypes?.length && { globalTypes }),
      ...additionalDesignerParams,
    };

    if (options?.lmsFetchId != null) {
      setIsDesignersLoading(true);
    }

    const designerRequest = isLMS
      ? fetchLmsDesignerAutoComplete(searchText)
      : DesignerAPI.AutoComplete(designerParams);

    return designerRequest
      .then((v) => v.json())
      .then((raw) => API.toLang<Designer[]>(raw, i18n.language))
      .then((v) => {
        if (
          options?.lmsFetchId != null &&
          options.lmsFetchId !== lmsSearchFetchIdRef.current
        ) {
          return;
        }
        setDesigners(v);
      })
      .finally(() => {
        if (
          options?.lmsFetchId != null &&
          options.lmsFetchId === lmsSearchFetchIdRef.current
        ) {
          setIsDesignersLoading(false);
        }
      });
  };

  const fetchLmsCourses = async (lmsFetchId: number) => {
    setIsLoading(true);
    try {
      const response = await API.request()
        .endpoint(Endpoints.geograffee)
        .url("/api/LMS/AutoCompletePaging")
        .get()
        .addQuery("key", searchText)
        .addQuery("page", currentPage)
        .addQuery("limit", SEARCH_REQUEST_LIMIT)
        .send();
      const json = await response.json();
      if (lmsFetchId !== lmsSearchFetchIdRef.current) {
        return;
      }
      const v = API.toLang<PageModel<Project>>(json, i18n.language);
      setTeams(v.data ?? []);
      // @ts-ignore
      setPages(v.paging?.pages ?? 0);
    } finally {
      if (lmsFetchId === lmsSearchFetchIdRef.current) {
        setIsLoading(false);
      }
    }
  };

  // const fetchChannels = async () => {
  //   setIsLoading(true)
  //   return (
  //     API.request()
  //     .endpoint(Endpoints.geograffee)
  //     .url('/api/Team/GetChannelsAutoCompletePaging')
  //     .get()
  //     .addQuery('key', searchText)
  //     .addQuery('page', currentPage)
  //     .addQuery('limit', SEARCH_REQUEST_LIMIT)
  //     .send()
  //     .then((v) => v.json())
  //     .then((v) => {
  //       setChannels(API.toLang<Team[]>(v.data, i18n.language));
  //       setPages(v.paging.pages);
  //       setIsEmpty(v.length < 1);
  //       setIsLoading(false);
  //     })
  //   )
  // }

  const fetchOrganizations = async () => {
    const orgParams = {
      key: searchText,
      limit: Number(SEARCH_REQUEST_LIMIT),
    };

    const v = await TeamAPI.TeamAutoComplete(orgParams);
    const json = await v.json();
    const data = API.toLang<Team[]>(json, i18n.language);
    setOrganizations(Array.isArray(data) ? data : []);
  };

  useLayoutEffect(() => {
    if (!isLMS || searchText.length < 2) return;
    setIsLoading(true);
    setIsDesignersLoading(true);
  }, [searchText, isLMS]);

  useEffect(() => {
    if (!isLMS || searchText.length < 2) return;
    if (isLoading || isDesignersLoading) {
      setIsEmpty(false);
      return;
    }
    if (lmsActiveSearchRef.current !== searchText) {
      setIsEmpty(false);
      return;
    }
    if (designers.length === 0 && teams.length > 0) {
      setIsEmpty(true);
      return;
    }
    setIsEmpty(designers.length === 0 && teams.length === 0);
  }, [
    isLMS,
    searchText,
    isLoading,
    isDesignersLoading,
    designers.length,
    teams.length,
  ]);

  useDebouncedEffect(
    () => {
      if (searchText.length >= 2) {
        if(isLMS){
          lmsActiveSearchRef.current = searchText;
          const fetchId = ++lmsSearchFetchIdRef.current;
          fetchLmsCourses(fetchId);
          fetchDesigners({ lmsFetchId: fetchId });
        }else{
          fetchProjects();
          fetchDesigners();
          if (!isAKI) {
            // fetchChannels();
            fetchOrganizations();
          }
        }
      } else {
        lmsSearchFetchIdRef.current += 1;
        lmsActiveSearchRef.current = '';
        setIsLoading(false);
        setIsDesignersLoading(false);
        setIsEmpty(false);
        setDesigners([]);
        setProjects([]);
        setTeams([]);
        // setChannels([]);
        setOrganizations([]);
      }
    },
    [searchText, i18n.language, currentPage],
    700
  );


  
  useEffect(() => {
    if(isLMS){
      //@ts-ignore
      setCombineData([...designers, ...(teams ?? [])]);
    } else if(isGreenAward){
      //@ts-ignore
      setCombineData([...(projects ?? [])])
    } else if (isAKI) {
      //@ts-ignore
      setCombineData([...designers, ...(projects ?? [])])
    } else {
      //@ts-ignore
      setCombineData([
        ...designers,
        ...(projects ?? []),
        // ...(channels ?? []) /*дублирование. каналы = организации*/,
        ...(organizations ?? []),
      ]);
    }
  }, [designers, projects, teams, channels, organizations, isLMS, isGreenAward, isAKI])

  useEffect(() => {
    const STYLE_ID = 'blur-18-style';
    document.getElementById(STYLE_ID)?.remove();
  
    const rules = combineData
      .map((item: any, idx: number) =>
        item.isAgeRestricted
          ? `.dropdown-search-auto-wrapper .item:nth-child(${idx + 1}) img { filter: blur(4px); }`
          : ''
      )
      .filter(Boolean)
      .join('\n');
  
    if (rules) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.innerHTML = rules;
      document.head.appendChild(style);
    }
  }, [combineData]);
  

  useEffect(() => {
    setCurrentPage(1)
  }, [isOpen])

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') return;
      if (!isOpen) return;
      const active = document.activeElement as HTMLElement | null;
      const wrapper = document.querySelector('.dropdown-search-auto-wrapper') as HTMLElement | null;
      const isTextInput =
        !!active &&
        (active.tagName === 'INPUT' ||
          active.tagName === 'TEXTAREA' ||
          !!(active as any).isContentEditable);
      if (wrapper) {
        if (!active || !wrapper.contains(active)) return;
      } else if (!isTextInput) {
        return;
      }
      if (searchText.trim().length >= 2 && !isAKI) {
        e.preventDefault();
        onClose?.();
        if (isLMS) {
          history.push(getFindLmsSearchPageUrl(searchText.trim()));
        } else {
          history.push(getFindProjectsPageUrl(searchText.trim()));
        }
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [searchText, isAKI, isLMS, onClose, history, isOpen]);

  //Сделал временно, потому что падало перед деплоем
  const isSearchResultLmsClick = useCallback((item: any, isProject?: boolean, isTeam?: boolean, isChannels?: boolean) => {
    let path: string;
    if (isProject) {
      path = CreateLinkTo.projectNew(item);
    } else if (isChannels) {
      path = CreateExternalLinkTo.mediiia('/teams/' + item?.teamId);
    } else if (isTeam) {
      path = CreateLinkTo.team(item?.teamId);
    } else {
      path = CreateLinkTo.designerNew(item);
    }
    onClose?.();
    window.open(path, '_blank', 'noopener,noreferrer');
  }, [onClose]);

  const mapLmsSearchResultItem = useCallback(
    (item: any) => {
      const cv = computeDesigner(item, { showFullName: true });
      const team = computeTeam(item);
      const isDesignerItem =
        !!(item?.designerId || item?.accountId) && !item?.teamId && !item?.projectId;

      if (isDesignerItem) {
        return {
          onClick: () => isSearchResultLmsClick(cv, false, false, false),
          avatarCV: cv,
          name: cv?.fullName || "",
          title: "",
          titleImages: [] as unknown,
          projectId: "",
          projectType: undefined,
          designerId: cv?.designerId || "",
          id: cv?.designerId,
          teamId: "",
          isProject: false,
          isTeam: false,
          isChannels: false,
        };
      }

      const imagesContainer = getCourseImages(item);
      const images = imagesContainer?.[0]?.files;
      const isTeam =
        !!item?.teamId &&
        ![ModerationType.Outer, ModerationType.ChannelGroupOrCourse]?.includes(
          item.moderationType,
        );
      const isChannels =
        item?.teamId &&
        [ModerationType.Outer, ModerationType.ChannelGroupOrCourse]?.includes(
          item.moderationType,
        );

      const searchMatch = item?.searchMatch as
        | { field?: number; values?: string[]; fragments?: string[] }
        | undefined;

      return {
        onClick: () =>
          isSearchResultLmsClick(team, false, isTeam, isChannels),
        avatarCV: cv,
        name: team?.name || team?.displayName || "",
        title: team?.name || team?.displayName || "",
        searchMatchField: searchMatch?.field,
        searchMatchValues: searchMatch?.values,
        searchMatchFragments: searchMatch?.fragments,
        // @ts-ignore
        titleImages: item?.titleImages?.length
          ? item?.titleImages
          : images?.length
            ? images
            : ([] as unknown),
        projectId: "",
        projectType: undefined,
        designerId: "",
        id: item?.teamId,
        teamId: team?.teamId || item?.teamId,
        isProject: false,
        isTeam,
        isChannels,
      };
    },
    [isSearchResultLmsClick],
  );

  const onSearchResultItemClick = useCallback((item: any) => {
    let path: string;
    if (item?.hasOwnProperty('projectId')) {
      path = CreateLinkTo.projectNew(item);
    } else if (item?.hasOwnProperty('teamId') && item?.hasOwnProperty('moderationType')) {
      path = CreateExternalLinkTo.mediiia('/teams/' + item?.teamId);
    } /*else if (isTeam) {
      path = CreateLinkTo.team(item?.teamId);
    } */else {
      path = CreateLinkTo.designerNew(item);
    }
    onClose?.();
    window.open(path, '_blank', 'noopener,noreferrer');
  }, [onClose]);


  const SearchPortal = useMemo(() => {
    if (isServer) return null;
    if (isLMS) {
      
      const outer = document.querySelector('#navbar-portal');

      if (!outer && !isOpen) return null;
  
      if (outer) {
            //@ts-ignore
        outer.style.position = 'relative';
      }
  
      return createPortal(
  
        <AutoWrapper className="dropdown-search-auto-wrapper" isLogged={!!profile}  isCGRAVE={isCGRAVE || isContinuumSite} style={wrapperStyle}>
        <NavBavDropDownSearchTabs
        resultsData={[...combineData].map(mapLmsSearchResultItem)}
        searchText={searchText}
        setSearchText={setSearchText}
        isEmpty={isEmpty}
        isLMS={isLMS}
        Endpoints={Endpoints}
        isLoading={isLoading || isDesignersLoading}
        pages={pages}
        placeholderImg={placeholderImg}
        minTextLength={2}
        orientation={orientation}
        onClose={onClose}
        onWhiteBg={!isGeo && !isSuperpuper}
        autoOpen={autoOpen}
        forceOpen={true}
        initialTab="projects"
        tabsOrder={['projects', 'people']}
        tabsLoading={{
          projects: isLoading,
          people: isDesignersLoading,
        }}
        showAllButton={{
          label: t("show_all"),
          getHref: (search) => getFindLmsSearchPageUrl(search),
        }}
        texts={{
            needMoreChars: t('text.more2chars'),
            loading: t('text.loading'),
            notFound: t('text.notfound'),
            newSearch: t('new_search_common_lms'),
            hintTooltip: t("hints.search_lms"),
            tabs: {
              people: t("main_search.tabs.people"),
              projects: t("main_search.tabs.courses"),
            }
        }}
        modalPaginationComponent={
          <ModalPagination
              pages={pages}
              page={currentPage}
              onPageChange={(page) => {
                  setCurrentPage(page);
              }}
          />
      }
    />
          </AutoWrapper>
       ,
       outer as Element,
      );
    }

    if (autoOpen) {
      const outer = document.querySelector('#navbar-portal');

      if (!outer && !isOpen) return null;
  
      if (outer) {
            //@ts-ignore
        outer.style.position = 'relative';
      }
  
      return createPortal(
  
        <AutoWrapper className="dropdown-search-auto-wrapper" isLogged={!!profile}  isCGRAVE={isCGRAVE || isContinuumSite} style={wrapperStyle}>
        <NavBavDropDownSearchTabs
        resultsData={[...combineData].map((item) => {
  
          const cv = computeDesigner(item, { showFullName: true });
          const project = computeProject(item);
          //const team = computeTeam(item);
          const channel = computeTeam(item);
          //@ts-ignore
          const isProject = !!item?.projectId
          const isCommonTeamSign = !!channel?.teamId;
          const images = getPresentationImages(item)

          let entity: any | undefined = undefined;
          
          if (isProject) {
            entity = project;
          } else if (isCommonTeamSign) {
            entity = channel;
          } else {
            entity = cv;
          }

          return {
            onClick: () => onSearchResultItemClick(entity),
              avatarCV: cv,
              name: cv?.fullName || '',
              title: entity?.title || '',
              titleImages: entity?.titleImages || images || [] as unknown,
              projectId: entity?.projectId || '',
              projectType: entity?.projectType,
              designerId: !isProject && !isCommonTeamSign ? (entity?.designerId || '') : '',
              id: project?.projectId || cv?.designerId || channel?.teamId,
              teamId: entity?.teamId ?? '',
              isProject: isProject, 
              isTeam: undefined,
              isChannels: isCommonTeamSign
          }
      })}
        searchText={searchText}
        setSearchText={setSearchText}
        isEmpty={isEmpty}
        Endpoints={Endpoints}
        isLoading={isLoading}
        pages={pages}
        minTextLength={2}
        orientation={orientation}
        onClose={onClose}
        onWhiteBg={!isGeo && !isSuperpuper}
        autoOpen={autoOpen}
        forceOpen={true}
        showAllButton={!isAKI ? { label: t('show_all'), getHref: (search) => getFindProjectsPageUrl(search) } : undefined}
        texts={{
            needMoreChars: t('text.more2chars'),
            loading: t('text.loading'),
            notFound: t('text.notfound'),
            newSearch: t(isGreenAward ? 'new_search_prject' : 'new_search_common'),
            hintTooltip: t("hints.search"),
            tabs: {
              people: t("main_search.tabs.people"),
              projects: t("main_search.tabs.projects"),
              channels: t("main_search.tabs.organizations"),
            }
        }}
        modalPaginationComponent={
          <ModalPagination
              pages={pages}
              page={currentPage}
              onPageChange={(page) => {
                  setCurrentPage(page);
              }}
          />
      }
    />
          </AutoWrapper>
       ,
       outer as Element,
      );
    }
   
  
    // @ts-ignore
    const mappedResults = [...combineData].map((item) => {
          const cv = computeDesigner(item,  { showFullName: true });
          const project = computeProject(item);
          const channel = computeTeam(item);
          const isProject = !!project?.projectId;
          const isCommonTeamSign = !!channel?.teamId

          let entity: any | undefined = undefined;
          
          if (isProject) {
            entity = project;
          } else if (isCommonTeamSign) {
            entity = channel;
          } else {
            entity = cv;
          }

          return {
            onClick: () => onSearchResultItemClick(entity),
            avatarCV: cv,
            name: cv?.fullName || '',
            title: project?.title || '',
            titleImages: project?.titleImages || [] as unknown,
            projectId: project?.projectId || '',
            designerId: !isProject && !isCommonTeamSign ? (entity?.designerId || '') : '',
            projectType: project?.projectType,
            id: project?.projectId || cv?.designerId || channel?.teamId,
            teamId: channel?.teamId ?? '',
            isProject: isProject,
            isChannels: isCommonTeamSign
          }
      });
    const showAllItem = !isAKI && searchText.trim().length >= 2 ? {
      designerId: '__show_all__' as const,
      name: t('show_all'),
      onClick: () => {
        onClose?.();
        window.open(getFindProjectsPageUrl(searchText.trim()), '_blank', 'noopener,noreferrer');
      },
    } : null;
    const resultsData: any[] = showAllItem ? [showAllItem, ...mappedResults] : mappedResults;


    return (      <NavBavDropDownSearchTabs
      resultsData={resultsData}
      searchText={searchText}
      setSearchText={setSearchText}
      isEmpty={isEmpty}
      isLoading={isLoading}
      pages={pages}
      minTextLength={2}
      orientation={orientation}
      Endpoints={Endpoints}
      autoOpen={autoOpen}
      onWhiteBg={!isGeo && !isSuperpuper}
      modalPaginationComponent={
        <ModalPagination
            pages={pages}
            page={currentPage}
            onPageChange={(page) => {
                setCurrentPage(page);
            }}
        />
      }
      texts={{
          needMoreChars: t('text.more2chars'),
          loading: t('text.loading'),
          notFound: t('text.notfound'),
          newSearch: t('new_search'),
          hintTooltip: t("hints.search"),
          tabs: {
            people: t("main_search.tabs.people"),
            projects: t("main_search.tabs.projects"),
            // organizations: t("main_search.tabs.organizations"),
            ...(!isAKI && { channels: t("main_search.tabs.channels") })
          }
      }}
  />
    )
   
  }, [
    isOpen,
    autoOpen,
    searchText,
    isSuperpuper,
    isGeo,
    designers,
    teams,
    projects,
    combineData,
    isEmpty,
    isLoading,
    isDesignersLoading,
    pages,
    currentPage,
    isLMS,
    isAKI,
    isGreenAward,
    mapLmsSearchResultItem,
    t,
    orientation,
    onClose,
    profile,
    isCGRAVE,
    isContinuumSite,
    Endpoints,
  ])


  if (autoOpen && !isOpen) return null;

  return (
      <>
        {SearchPortal}
      </>
  );
};